(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-header"]) return;
  try {
    
  (() => {
    const section = document.currentScript && document.currentScript.closest('.shopify-section');
    const root = section || document;
    const nav = root.querySelector('.primary-nav');
    const menus = nav ? [...nav.querySelectorAll('.primary-nav__item')] : [];
    const closeDesktopMenus = (keep) => menus.forEach((menu) => { if (menu !== keep) menu.removeAttribute('open'); });
    const positionDesktopPanel = () => { if (nav) { const navRect = nav.getBoundingClientRect(); nav.style.setProperty('--ak-menu-top', `${Math.max(8, navRect.bottom)}px`); } };
    menus.forEach((menu) => menu.addEventListener('toggle', () => { if (menu.open) { closeDesktopMenus(menu); positionDesktopPanel(); } }));
    menus.forEach((menu) => {
      const familyButtons = [...menu.querySelectorAll('[data-nav-family]')];
      const panes = [...menu.querySelectorAll('[data-nav-pane]')];
      const selectFamily = (handle) => {
        familyButtons.forEach((button) => {
          const active = button.dataset.navFamily === handle;
          button.classList.toggle('is-featured', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panes.forEach((pane) => {
          const active = pane.dataset.navPane === handle;
          pane.classList.toggle('is-active', active);
          pane.hidden = !active;
        });
      };
      familyButtons.forEach((button) => button.addEventListener('click', () => selectFamily(button.dataset.navFamily)));
      if (familyButtons[0]) selectFamily(familyButtons[0].dataset.navFamily);
    });
    const mobileMenu = root.querySelector('#AkMobileMenu');
    const toggle = root.querySelector('.mobile-menu-toggle');
    const closeButton = root.querySelector('.mobile-menu__close');
    if (mobileMenu && toggle && closeButton) {
      toggle.addEventListener('click', () => { mobileMenu.showModal(); toggle.setAttribute('aria-expanded', 'true'); });
      closeButton.addEventListener('click', () => { mobileMenu.close(); toggle.setAttribute('aria-expanded', 'false'); });
      mobileMenu.addEventListener('click', (event) => { if (event.target === mobileMenu) { mobileMenu.close(); toggle.setAttribute('aria-expanded', 'false'); } });
      mobileMenu.addEventListener('close', () => { toggle.setAttribute('aria-expanded', 'false'); });
      const mobileDetails = [...mobileMenu.querySelectorAll('details')];
      mobileDetails.forEach((detail) => detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        mobileDetails.forEach((other) => { if (other !== detail && !detail.contains(other) && !other.contains(detail)) other.removeAttribute('open'); });
      }));
    }
    window.addEventListener('resize', positionDesktopPanel, { passive: true });
    document.addEventListener('click', (event) => { if (nav && !nav.contains(event.target)) closeDesktopMenus(null); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDesktopMenus(null); });
  })();

  } catch(e) { console.error(e); }
})();
})();
